import updateRequest from "./requests/update-request";
import deleteRequest from "./requests/delete-request";
import getByIdRequest from "./requests/get-by-id-request";
import addRequest from "./requests/add-request";
import setConfigRequest from "./requests/set-config-request";
import getUnionForHistoryRequest from "./requests/get-union-for-history-request";
import getHistoryRequest from "./requests/get-history-request";
import deleteUnionRequest from "./requests/delete-union-request";
import getUnionRequest from "./requests/get-union-request";
import setUnionRequest from "./requests/set-union-request";
import deleteModificationRequest from "./requests/delete-modification-request";
import addModificationRequest from "./requests/add-modification-request";
import getModificationsRequest from "./requests/get-modifications-request";
import setModificationDefaultRequest from "./requests/set-modification-default-request";
import searchRequest from "./requests/search-request";
import getStatisticRequest from "./requests/get-statistic-request";
import printClientsRequest from "./requests/print-clients-request";
import getWithPaginationRequest from "./requests/get-with-pagination-request";
import getConfigRequest from "./requests/get-config-request";
import getFilterCountsRequest from "./requests/get-filter-counts-request";

const clientsRepository = {
    update: updateRequest,
    delete: deleteRequest,
    getById: getByIdRequest,
    add: addRequest,
    setConfig: setConfigRequest,
    getUnionForHistory: getUnionForHistoryRequest,
    getHistory: getHistoryRequest,
    deleteUnion: deleteUnionRequest,
    getUnion: getUnionRequest,
    setUnion: setUnionRequest,
    deleteModification: deleteModificationRequest,
    addModification: addModificationRequest,
    getModifications: getModificationsRequest,
    setModificationDefault: setModificationDefaultRequest,
    search: searchRequest,
    getStatistic: getStatisticRequest,
    printClients: printClientsRequest,
    getWithPagination: getWithPaginationRequest,
    getConfig: getConfigRequest,
    getFilterCounts: getFilterCountsRequest,
};

export default clientsRepository;